/**
 * =====================================================================
 * IMPORTANT - READ BEFORE MODIFYING ANY LIST ENDPOINT IN THIS FILE:
 * =====================================================================
 *
 * TNN's Django backend paginates ALL list endpoints by default:
 *
 *   API returns: { "count": N, "results": [...actual data...] }
 *   baseApi unwraps to: { "count": N, "results": [...] }  (NOT an array)
 *
 * Every ``build.query<Type[], ...>`` endpoint MUST have:
 *
 *   transformResponse: (r: { results?: Type[] }) =>
 *     Array.isArray(r?.results) ? r.results : [],
 *
 * Without this, ``.map()`` on the paginated object either crashes
 * ("TypeError: x.map is not a function") or silently shows nothing.
 * This was the #1 bug class in the v1.6 and v4.0.1 QA reports.
 * =====================================================================
 */
/**
 * Deployment API.
 *
 * One endpoint: GET /api/v1/deployment/ - the public, pre-login
 * descriptor of what kind of deployment this is. Fetched once at
 * startup; the value never changes within a session (a deployment
 * can't change mode without a redeploy), so it's effectively static.
 */
import { baseApi } from "@/app/store/api/baseApi";

import type { DeploymentInfo } from "../model/types";

/** RTK Query endpoint for deployment metadata. */
export const deploymentApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getDeploymentInfo: build.query<DeploymentInfo, void>({
      query: () => "/deployment/",
      // Deployment shape is immutable for the life of the process;
      // never needs refetching.
      keepUnusedDataFor: Infinity,
    }),
  }),
  overrideExisting: false,
});

export const { useGetDeploymentInfoQuery } = deploymentApi;
